export default "__VITE_PUBLIC_ASSET__e73de38a__"